module.exports = __webpack_public_path__ + "img/logo.c23eb914.png";